import React from "react";
import {Badge} from "react-bootstrap";

const ElevatorBadge: React.FC = () => (
    <Badge bg="warning text-dark" className="ms-2">Elevator</Badge>
);

export default ElevatorBadge;
